import styled from 'styled-components';

export const PlaylistEditorContainer = styled.div`
    --headers-height: 4rem;
    --playlist-editor-header-height: ${(props) =>
        props.$extendedFilters ? '12rem' : 'var(--headers-height)'};
    --item-width: 6rem;
    --item-width-playlist: 9rem;
    --archive-width: 42rem;
    --playlist-page-inner-gap: 0.25rem;
    --playlist-page-outer-gap: 2rem;
    --playlist-page-vertical-gap: 1rem;
    --top-offset: 3.65rem;

    /* @media (max-width: 1800px) {
        --item-width: 5rem;
        --archive-width: 27rem;
    } */
    @media (max-width: 1980px) {
        --archive-width: 36rem;
    }
    @media (max-width: 1600px) {
        --archive-width: 30rem;
    }

    --item-preview-trigger-height: 2rem;

    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;

    .playlist-editor-left {
        //width: calc(95vw - 40rem);
        width: 1600px;
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        justify-content: flex-start;
        align-items: flex-start;
        position: fixed;
        top: var(--top-offset);
        left: calc(2vw + 1rem);
        z-index: 0;

        @media (max-width: 2270px) {
            width: 1280px;
        }
        @media (max-width: 1860px) {
            width: 980px;
        }
        /* @media (max-width: 1980px) {
            width: 1074px;
        }
        @media (max-width: 1600px) {
            width: 820px;
        } */

        .playlist-editor-left-header {
            /* background-color: #fff;
            border-radius: 4px 4px 0 0;
            box-shadow:
                0px 2px 1px rgba(3, 7, 18, 0.08),
                0px 7px 4px rgba(3, 7, 18, 0.06),
                0px 16px 9px rgba(3, 7, 18, 0.05),
                0px 28px 15px rgba(3, 7, 18, 0.03),
                0px 44px 24px rgba(3, 7, 18, 0.02);
             */

            height: var(--headers-height);
            width: calc(100% - 4rem);
            padding: 0.25rem 2rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .playlist-header-title {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                gap: 1rem;

                h2 {
                    font-size: ${(props) => props.theme.FontSizeBase};
                    font-weight: 600;
                    margin: 0;
                }

                .ant-btn {
                    font-size: ${(props) => props.theme.FontSizeSm};
                    text-transform: uppercase;
                }
            }

            .playlist-header-buttons {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 1rem;
            }
        }

        .playlist-editor-left-body {
            /* background-color: ${(props) =>
                props.theme.LayoutBodyBackgroundTransparent}; */
            height: calc(100vh - 14rem);
            width: 100%;
            overflow: hidden;
            position: relative;
            /* background-color: #fff; */

            .scrollbar-container {
                .ps__rail-y {
                    left: auto !important;
                    right: 0 !important;
                }
            }

            .playlist-grid {
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                align-content: flex-start;
                flex-wrap: wrap;
                gap: var(--playlist-page-vertical-gap)
                    var(--playlist-page-inner-gap);
                padding: 1rem;
                width: 100%;
                min-height: calc(100vh - 13rem);
                padding-bottom: 10rem;
                /* background-color: red; */

                .playlist-grid-item {
                    width: var(--item-width-playlist);
                    height: auto;
                    aspect-ratio: 3/4;

                    background-color: ${(props) =>
                        props.theme.DarkerBorderColor};
                    color: #fff;
                    font-size: 0.8rem;
                    overflow: hidden;
                    position: relative;

                    .ant-image {
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                        .ant-image-mask {
                            bottom: auto;
                            left: auto;
                            width: 100%;
                            height: var(--item-preview-trigger-height);
                            background-color: #000;
                            opacity: 0.25;

                            &:hover {
                                opacity: 0.8;
                                background-color: ${(props) =>
                                    props.theme.PrimaryColor};
                            }
                        }
                    }

                    .draggable-image-handler {
                        background-color: transparent;
                        position: absolute;
                        top: 0;
                        right: 0;
                        left: 0;
                        bottom: var(--item-preview-trigger-height);
                        cursor: move;
                    }

                    &.landscape {
                        width: calc((var(--item-width-playlist) * 2) + 1rem);
                        aspect-ratio: 16/10;
                    }
                }
            }
        }
    }

    .playlist-editor-right {
        position: relative;
        //padding-top should be --playlist-editor-header-height + .5rem
        padding-top: calc(var(--playlist-editor-header-height) + 0.75rem);
        background-color: #fff;

        .playlist-editor-right-header {
            /* border-radius: 4px;
            box-shadow:
                0px 2px 1px rgba(3, 7, 18, 0.08),
                0px 7px 4px rgba(3, 7, 18, 0.06),
                0px 16px 9px rgba(3, 7, 18, 0.05),
                0px 28px 15px rgba(3, 7, 18, 0.03),
                0px 44px 24px rgba(3, 7, 18, 0.02); */

            height: var(--playlist-editor-header-height);
            width: var(--archive-width);
            position: fixed;
            top: var(--top-offset);
            border-bottom: ${(props) => props.theme.DefaultBorder};
            right: 0;
            z-index: 300;

            padding: 2rem;
            background-color: #fff;

            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;

            .archive-header {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .archive-header-control {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 0.5rem;

                    span {
                        font-size: ${(props) => props.theme.FontSizeSm};
                        color: ${(props) => props.theme.TextColorMuted};
                        text-transform: uppercase;
                    }
                }
            }
        }

        .playlist-editor-right-body {
            //background-color: ${(props) => props.theme.LayoutBodyBackground};
            width: var(--archive-width);
            min-height: calc(100vh - 12rem);
            padding: 1rem;

            .pictures-archive-list {
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                flex-wrap: wrap;
                gap: 0.75rem;
            }
        }
    }
`;
